import { render, staticRenderFns } from "./InvestorProfileInvestmentType.vue?vue&type=template&id=e8b9f1d8&"
import script from "./InvestorProfileInvestmentType.vue?vue&type=script&lang=ts&"
export * from "./InvestorProfileInvestmentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRadio,VRadioGroup,VRow})
